import { DateTime } from '@westondev/tableturn-core';
import Input from '../Input';
import { IInput } from '../Input/Input';

interface DatePickerProps extends Omit<IInput, 'onChange' | 'value' | 'type'> {
  value: string;
  onChange: (newValue: string) => void;
  minValue?: string;
  maxValue?: string;
}

const DatePicker = ({
  value,
  onChange,
  maxValue,
  minValue,
  ...props
}: DatePickerProps) => {
  const getLocaleValue = (utcDateTime: string | null | undefined) => {
    if (!utcDateTime && utcDateTime !== undefined) {
      return '';
    }
    if (!utcDateTime) {
      return undefined;
    }

    const dt = DateTime.fromISO(utcDateTime, { zone: 'utc' });
    return dt.setZone('utc').toFormat('yyyy-MM-dd');
  };

  const getUTCValue = (localDateTime: string | null | undefined) => {
    if (!localDateTime) {
      return undefined;
    }

    const dt = DateTime.fromISO(localDateTime, { zone: 'utc' });
    return dt.setZone('utc').toISO();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputtedDateTime = e.target.value;
    const convertedDateTime = getUTCValue(inputtedDateTime);
    onChange(convertedDateTime || '');
  };

  const currentValue = getLocaleValue(value);
  const min = getLocaleValue(minValue);
  const max = getLocaleValue(maxValue);

  return (
    <Input
      {...props}
      csx={theme =>
        !value
          ? {
              '&::-webkit-datetime-edit': {
                color: theme.colors.semanticGrey,
              },
            }
          : undefined
      }
      type="date"
      value={currentValue}
      onChange={handleChange}
      max={max}
      min={min}
    />
  );
};

export default DatePicker;
